import * as fuegokitComponents from "@fuegokit/react";
import { InlineCode } from "@fuegokit/gatsby-theme-fuegodocs/src/components/Code";
import {
  AlertDialogDefaultExample,
  AlertDialogDangerExample,
  AlertDialogWarningExample,
  AlertDialogSuccessExample,
  StyledSwitchExample,
  StyledDropdownExample,
  ControlledStyledDropdownExample,
  StyledComboboxExample,
  StyledDatepickerExample,
  StyledToastExample,
  StyledPositionAwareItemExample,
  StyledRuleBuilderLayoutExample,
  StyledRuleBuilderStepsExample,
  StyledRuleBuilderStepExample,
  StyledRuleDetailExample,
  StyledDialogExample,
  StyledAccordionExample,
  StyledSelectExample,
  StyledAvatarExample,
  StyledScrollAreaExample,
  StyledTooltipExample,
  StyledTabsExample,
  StyledStepsExample,
  BasicUseDragExample,
} from "../../../examples";
import { PropsTable } from "../../PropsTable";
import { ComponentProps } from "../../ComponentProps";
import { LandingReactPage } from "./components";

export default {
  ...fuegokitComponents,
  InlineCode,
  ComponentProps,
  // MDX1 doesn't support rendering subcomponents with dot notation
  // so we need to alias them
  PropsTableRow: PropsTable.Row,
  PropsTableBasePropRows: PropsTable.BasePropRows,
  PropsTablePassthroughPropsRow: PropsTable.PassthroughPropsRow,
  PropsTableAsRow: PropsTable.AsRow,
  PropsTableRefRow: PropsTable.RefRow,
  PropsTableSxRow: PropsTable.SxRow,
  // examples
  AlertDialogDefaultExample,
  AlertDialogDangerExample,
  AlertDialogWarningExample,
  AlertDialogSuccessExample,
  StyledSwitchExample,
  StyledDropdownExample,
  ControlledStyledDropdownExample,
  StyledComboboxExample,
  StyledDatepickerExample,
  StyledToastExample,
  StyledPositionAwareItemExample,
  StyledRuleBuilderLayoutExample,
  StyledRuleBuilderStepsExample,
  StyledRuleBuilderStepExample,
  StyledRuleDetailExample,
  StyledDialogExample,
  StyledAccordionExample,
  StyledSelectExample,
  StyledAvatarExample,
  StyledScrollAreaExample,
  StyledTooltipExample,
  StyledTabsExample,
  StyledStepsExample,
  BasicUseDragExample,
  //
  LandingReactPage,
};
